export class PointsTotal {
  points: number;
  raffleTickets: number;
}
